import React from "react";
import PropTypes from "prop-types";
import StringField from "../../components/StringField";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";

function AreaSelect({
  id,

  label,
  schema,
  value,
  formContext
}: any) {
  const { t } = useSchemaTranslation();

  return <StringField id={id} label={t(schema.title || label)} value={value ?? formContext.emptyValue} />;
}

AreaSelect.defaultProps = {
  options: {
    semantic: {
      fluid: true,
      inverted: false,
    },
  },
};

AreaSelect.propTypes = {
  options: PropTypes.object,
};

export default AreaSelect;
